import { useRoutes } from 'react-router-dom';
import { path } from '../../paths';
import { onBasePath } from '../../paths/onBasePath';
import { OutputDataObjectDirectory } from './OutputDataObjectDirectory';
import { FC } from 'react';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './translations/OutputDataObjects.translations.json';
import { OutputDataObjectDetails } from './OutputDataObjectDetails';
import { OutputDataObjectCreate } from './OutputDataObjectCreate';
import { OutputDataObjectEdit } from './OutputDataObjectEdit';
import { DataObjectBreadcrumbsData } from '../data-objects/DataObjectBreadcrumbs';
import { NotFound } from '../NotFound';
import { OutputDataObjectClone } from './OutputDataObjectClone';

const { addTranslations, Translation } = i18nNsFactory('output-data-objects');
addTranslations(translations);

export const OUTPUT_DATA_OBJECT_ROUTES = [
  {
    path: path.outputDataObjectDirectory,
    renderBreadcrumb: () => (
      <Translation>{(t) => t('breadcrumb.output-data-objects')}</Translation>
    ),
    children: [
      {
        index: true,
        element: <OutputDataObjectDirectory />,
      },
      {
        path: path.outputDataObjectCreate,
        element: <OutputDataObjectCreate />,
        renderBreadcrumb: () => (
          <Translation>
            {(t) => t('breadcrumb.create-output-data-object')}
          </Translation>
        ),
      },
      {
        path: path.outputDataObjectView,
        renderBreadcrumb: (data?: DataObjectBreadcrumbsData) =>
          data?.dataObjectVersion ? (
            data.dataObjectVersion.code + ' - ' + data.dataObjectVersion.name
          ) : (
            <Translation>
              {(t) => t('breadcrumb.output-data-object-details')}
            </Translation>
          ),
        children: [
          {
            index: true,
            element: <OutputDataObjectDetails />,
          },
        ],
      },
      {
        path: path.outputDataObjectEdit,
        element: <OutputDataObjectEdit />,
        renderBreadcrumb: (data?: DataObjectBreadcrumbsData) =>
          data?.dataObjectVersion ? (
            data.dataObjectVersion.code + ' - ' + data.dataObjectVersion.name
          ) : (
            <Translation>{(t) => t('breadcrumb.edit-data-object')}</Translation>
          ),
      },
      {
        path: path.outputDataObjectClone,
        element: <OutputDataObjectClone />,
        renderBreadcrumb: () => (
          <Translation>{(t) => t('breadcrumb.clone-data-object')}</Translation>
        ),
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export const OutputDataObjects: FC<{ basePath: string }> = ({ basePath }) =>
  useRoutes(onBasePath(basePath, OUTPUT_DATA_OBJECT_ROUTES));
